import { cn, semanticColors } from '@/utils'

const CATEGORY_BARS = [
  { name: 'Income', inflow: 95, outflow: 0 },
  { name: 'Rent', inflow: 0, outflow: 58 },
  { name: 'Food', inflow: 0, outflow: 42 },
  { name: 'Transfers', inflow: 28, outflow: 12 },
  { name: 'Transport', inflow: 0, outflow: 24 },
  { name: 'Gen. merch.', inflow: 0, outflow: 18 },
] as const

const CATEGORY_BAR_MAX = Math.max(
  ...CATEGORY_BARS.map((bar) => bar.inflow + bar.outflow),
)

export const CategoriesPreview = () => {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex flex-1 items-end gap-1.5 px-0.5">
        {CATEGORY_BARS.map((bar) => {
          const inflowHeight = (bar.inflow / CATEGORY_BAR_MAX) * 100
          const outflowHeight = (bar.outflow / CATEGORY_BAR_MAX) * 100
          return (
            <div
              key={bar.name}
              className="flex h-full flex-1 flex-col justify-end"
            >
              {bar.inflow > 0 && (
                <div
                  className="w-full rounded-t-sm"
                  style={{
                    height: `${inflowHeight}%`,
                    backgroundColor: semanticColors.inflow,
                  }}
                />
              )}
              {bar.outflow > 0 && (
                <div
                  className={cn('w-full', bar.inflow === 0 && 'rounded-t-sm')}
                  style={{
                    height: `${outflowHeight}%`,
                    backgroundColor: semanticColors.outflow,
                  }}
                />
              )}
            </div>
          )
        })}
      </div>
      <div className="mt-1 flex gap-1.5 px-0.5">
        {CATEGORY_BARS.map((bar) => (
          <div
            key={bar.name}
            className="flex-1 truncate text-center text-[9px] text-muted-foreground"
          >
            {bar.name}
          </div>
        ))}
      </div>
    </div>
  )
}
